import {Injectable} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private snackBar: MatSnackBar) {
  }

  public openSnackBar(message: string, duration: number, type: string): void {
    this.snackBar.open(message,'Закрыть', {
      horizontalPosition: 'end',
      verticalPosition: 'top',
      duration: duration,
      panelClass: type
    } )
  }
}
